export default __webpack_public_path__ + "static/media/linuxworld.84994ee2.jpeg";